<template>
  <div class="flex flex-col gap-4">
    <Fieldset
      v-for="(child, i) in children"
      :key="i"
      :pt="{
        legend: 'p-2'
      }"
    >
      <template #legend>
        <div class="flex items-center gap-2">
          <div>{{ `Ребенок ${i + 1}` }}</div>
          <Button
            text
            security="secondary"
            icon="pi pi-minus"
            @click="removeChild(i)"
          />
        </div>
      </template>

      <ChildForm
        v-model:lastname="child.lastname"
        v-model:firstname="child.firstname"
        v-model:middlename="child.middlename"
        v-model:disability_date="child.disability_date"
        v-model:birthday="child.birthday"
        v-model:country="child.country"
        v-model:cohabitation="child.cohabitation"
        :birthday-error="getBirthdayError(i)"
      />
    </Fieldset>

    <Button
      label="Добавить ребенка"
      severity="secondary"
      icon="pi pi-plus"
      @click="addChild()"
    />
  </div>
</template>

<script setup lang="ts">
import { reactive, watch, toRaw } from 'vue';
import { ChildForm } from './ChildForm';
import { Child } from '@/entities/customer';
import Fieldset from 'primevue/fieldset';
import Button from 'primevue/button';

const props = defineProps<{
  errors: string[] | null;
}>();

const emits = defineEmits<{
  messageClose: [];
}>();

const model = defineModel<Child[] | null>();

const children = reactive<Child[]>([]);

if (model.value) {
  children.push(...toRaw(model.value));
}

const addChild = () => {
  children.push({
    lastname: '',
    firstname: '',
    middlename: '',
    disability_date: null,
    birthday: null,
    country: 'RU',
    cohabitation: false
  });
};

const removeChild = (index: number) => {
  children.splice(index, 1);
};

function getBirthdayError(index: number) {
  if (!props.errors?.length || children[index]?.birthday) {
    return null;
  }

  return props.errors[index] ?? props.errors[0];
}

watch(children, childrenList => {
  model.value = toRaw(childrenList);

  const hasEmptyBirthday = childrenList.some(child => !child.birthday);
  if (!hasEmptyBirthday && props.errors?.length) {
    emits('messageClose');
  }
});
</script>
